import React, { useState } from "react";
import { Routes, Route, useLocation } from "react-router-dom";
import ItemListContainer from "../components/ItemListContainer";
import ItemDetailContent from "./ItemDetailContent";
import Home from "./Home";
import Show from "./Show";
import Login from "./Login";
import NavMenu from "./NavMenu";
import Nav from "./Nav";
import BannerPromo from "./BannerPromo";
import Cart from "./Cart";
import { CartProvider } from "../context/CartContext";
import DetailPromo from "./DetailPromo";

const Main = () => {
  const location = useLocation().pathname;
  const [showCart, setShowCart] = useState(false);

  // --- LÓGICA DE AUTENTICACIÓN ---
  const [isAdminAuth, setIsAdminAuth] = useState(
    localStorage.getItem("isAdmin") === "true",
  );

  const handleCartModal = () => {
    setShowCart(!showCart);
  };

  const onLoginChange = (status) => {
    setIsAdminAuth(status);
  };

  return (
    // Colocamos el Provider aquí para que TODO el sitio tenga acceso al Context
    <CartProvider>
      {location !== "/admin" ? (
        <>
          {/* VISTA PARA CLIENTES */}
          <Nav handleCartModal={handleCartModal} />
          <NavMenu />
          <Cart show={showCart} handleModal={handleCartModal} />

          <div className="container-fluid sinBorde">
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/promo" element={<DetailPromo />} />
              <Route
                path="/categoria/:nombreCategoria/"
                element={<ItemListContainer />}
              />
              <Route
                path="/detalle/:idProducto/"
                element={
                  <ItemDetailContent handleCartModal={handleCartModal} />
                }
              />
              {/* Ruta admin dentro del flujo de cliente por si acaso */}
              <Route
                path="/admin"
                element={
                  isAdminAuth ? (
                    <Show onLogout={() => onLoginChange(false)} />
                  ) : (
                    <Login onLoginSuccess={() => onLoginChange(true)} />
                  )
                }
              />
            </Routes>
          </div>

          <BannerPromo handleCartModal={handleCartModal} />
        </>
      ) : (
        /* VISTA EXCLUSIVA /ADMIN */
        <div className="container-fluid sinBorde">
          <Routes>
            <Route
              path="/admin"
              element={
                isAdminAuth ? (
                  <Show onLogout={() => onLoginChange(false)} />
                ) : (
                  <Login onLoginSuccess={() => onLoginChange(true)} />
                )
              }
            />
            <Route path="/" element={<Home />} />
          </Routes>
        </div>
      )}
    </CartProvider>
  );
};

export default Main;
